import { Navigate } from "react-router-dom";
import type { ReactNode } from "react";

export default function RequireAuth({ children }: { children: ReactNode }) {
  const customerId =
    localStorage.getItem("customerId") ||
    sessionStorage.getItem("customerId");
  if (!customerId) return <Navigate to="/login" replace />;
  return <>{children}</>;
}
